import Vue from 'vue'
import App from './App'
import router from './router'
import Msg from 'vue-message'
import { Datetime } from 'vue-datetime'
import store from '@/store/index'
import Loading from 'vue-loading-overlay'
import VueSweetalert2 from 'vue-sweetalert2'

/* 匯入css樣式 */
import 'sweetalert2/dist/sweetalert2.min.css'
import 'vue-loading-overlay/dist/vue-loading.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'vue-datetime/dist/vue-datetime.css'
import './assets/css/font-awesome/css/font-awesome.min.css'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/custom.min.css'
import './assets/css/AddCss.css'
import './assets/css/element-ui.css'

/* 針對計時器延遲的處理套件 */
import HackTimer from '../node_modules/hacktimer/HackTimer.js'

import Moment from 'moment-timezone'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-TW'
import { firestorePlugin } from 'vuefire'

Vue.use(HackTimer)
Vue.use(firestorePlugin)
Vue.use(VueSweetalert2)
// 修改pagination的預設文字，將'項'改成'筆'
locale.el.pagination = {
  goto: '跳至',
  pagesize: '筆/頁',
  total: '共{total}筆',
  pageClassifier: '頁',
}
Vue.use(ElementUI, { locale })
Vue.use(Msg, {
  duration: 3000,
  background: 'rgba(7,17,27,0.7)',
})
Vue.use(Loading)
Vue.component('Loading', Loading)
Vue.component('datetime', Datetime)
Vue.prototype.$moment = Moment
Vue.config.productionTip = false
Vue.prototype.$bus = new Vue()

// 將 store 掛載到 window 上，方便在非 Vue 元件中使用（如 cookies.js）
window.__VUE_STORE__ = store

// 頁面載入時，從 cookies 恢復 teamRoles
import { restoreTeamRolesFromCookies } from '@/utils/cookies'
restoreTeamRolesFromCookies()

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js